import { Check, XCircle } from 'lucide-react';

import { Text } from '@/design-system/components/ui';

interface ValidationStatusProps {
  status: 'valid' | 'invalid';
  message: string;
}

export function ValidationStatus({ status, message }: ValidationStatusProps) {
  const isValid = status === 'valid';

  return (
    <div className="tw:flex tw:items-center tw:gap-1">
      {isValid ? (
        <Check className="tw:text-green-500 tw:shrink-0" size={16} />
      ) : (
        <XCircle className="tw:text-red-500 tw:shrink-0" size={16} />
      )}
      <Text variant="body-sm" className={isValid ? 'tw:text-green-600' : 'tw:text-red-500'}>
        {message}
      </Text>
    </div>
  );
}
